import '../styles/home2.css';
import { useState, useEffect } from 'react';
import LoadingScreen from '../components/loadingScreen';
import brandwork from '../resources/images/brandwork_edited.jpg';
import BottomContent from '../components/bottomContent';
import Carousel from '../components/carousel';
import camera from '../resources/images/Camera Vector-01.svg';
import { Link } from 'react-router-dom';
function Home() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('Home: Initial readyState:', document.readyState);
    const MIN_LOADING_TIME = 2500;
    const start = Date.now();
    let hasLoaded = false;

    const handleLoad = () => {
      hasLoaded = true;
      const timeElapsed = Date.now() - start;
      const remainingTime = MIN_LOADING_TIME - timeElapsed;
      console.log('Home: Load event fired, remainingTime:', remainingTime);
      setTimeout(() => {
        setIsLoading(false);
      }, remainingTime > 0 ? remainingTime : 0);
    };

    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      window.addEventListener('load', handleLoad);
      setTimeout(() => {
        if (!hasLoaded) {
          console.warn('Home: Fallback: forcing loading screen to close.');
          setIsLoading(false);
        }
      }, 5000); // Increased timeout
    }

    return () => window.removeEventListener('load', handleLoad);
  }, []);

  if (isLoading) {
    return <LoadingScreen startFadeOut={!isLoading} />;
  }

  return (
    
    <div className="container">
      {console.log('Home: Rendering content')}
      <div className="Background">
        <div className="b-image">
          <video
            src="/videos/short-bg.mp4"
            autoPlay
            loop
            muted
            playsInline
            poster="/images/public_site_img.png"
            onError={(e) => console.error('Home: Video error:', e)}
            onCanPlay={() => console.log('Home: Video can play')}
          >
            <source src="/videos/short-bg.mp4" type="video/mp4" />
            <img src="/images/public_site_img.png" alt="Fallback background" />
          </video>
        </div>
      </div>
      <div className="CreativeHead">
        <h3 className="kicker">Looking for something unique?</h3>
        <div className="CreativeText-cont">
          <h1 className="CreativeText">
            GRAPHIC DESIGN, PHOTOGRAPHY & VIDEOGRAPHY. OR <strong className="headerorange">WHATEVER.</strong>
          </h1>
        </div>
      </div>
      <div className="content">
        {console.log('Home: Rendering content div')}
        <div className="backgroundColor">
          <div className="hello"></div>
          <div className="identitySection">
            <div className="brandTitle">
              <h2><span className="brand">YOUR BRAND</span></h2>
              <span className="identity">YOUR IDENTITY, IN A NUTSHELL.</span>
            </div>
            <img src={brandwork} alt="brandwork.jpg" loading="lazy" />
            <div className="descriptionSection">
              <p className="description">
                Whether it's the brand of a large business, a solo entrepreneur's startup, or a personal brand, Mason Ayres Creative can help you express your voice with graphic design for your brand/site, stellar photography, and expressive, unique videography.
              </p>
              <p className="descriptionSmall">
                If you're looking for someone to help you unravel the mysteries of creative work, stop here. Our goal is to give honest, truly helpful, assistance for you and your business, no matter what it may be.
              </p>
            </div>
          </div>
          <div className="OurServices">
            <h2>OUR SERVICES</h2>
            <div className="services">
              <ul>
                <li>Logo Design</li>
                <li>Business Card Design</li>
                <li>Web Design</li>
                <li>Brand Strategy</li>
                <li>T-shirt Design</li>
                <li>Menu Design</li>
                <li>Page Layout/Book Design</li>
              </ul>
              <ul>
                <li>Motion Design/Animated Graphics</li>
                <li>Video Editing</li>
                <li>Commercial Videography</li>
                <li>Interview Videography</li>
                <li>Event Videography</li>
                <li>Product Videography</li>
                <li>Social Media Content Production</li>
              </ul>
              <ul>
                <li>Portrait Photography</li>
                <li>Product Photography</li>
                <li>Event Photography</li>
                <li>Photo Editing</li>
                <li>Business Strategy</li>
                <li>SEO Optimization</li>
                <li>Web Hosting</li>
                <li>Web Maintenance</li>
              </ul>
            </div>
          </div>
           <Carousel /> 
          <div className="videographySection">
            <div className="videographyHeader">
              <span>VIDEOGRAPHY & PHOTOGRAPHY</span>
            </div>
          </div>
          <div className="featured">
            <iframe
              src="https://www.youtube.com/embed/RQUw1GI__0E"
              title="Youtube Video"
              loading="lazy"
              allowFullScreen
            ></iframe>
          </div>
          <img src={camera} alt="camera-vector" className="camera" loading="lazy" />
          <h2 className="PhilHeader">MY PHILOSOPHY:</h2>
          <h2 className="ChaseHeader">CHASE ADVENTURE, CAPTURE THE STORY</h2>
          <div className="PhilDesc">
            <p className="PhilBody">
              There’s a lot of moments to miss out there. My goal when it comes to photos/video is to capture the moment as it feels, not just as it looks. Seeking out opportunities to capture unique moments is what I gravitate towards.
            </p>
            <p>
              Visit the <Link to="/photography" target="_top">Photography Page</Link> to see more!
            </p>
          </div>
          <div className="exposition">
            <p className="expohead">
              <strong>Well, you're down this far.</strong>
            </p>
            <p>
              If you want a creative partner who isn't afraid to break molds and try something new for your brand or business, you've found a pretty solid option to get shit done, and have fun doing it.
            </p>
            <p>Plus, we might bring cookies.</p>
          </div>
        </div>
        <div className="Bottom">
          <BottomContent />
        </div>
      </div>
    </div>
  );
}

export default Home;